import { ProductPageVisitPluginStateProps, ProductPageVisitPluginProps } from '../../types/components/user-interest-analytics/ProductPageVisitPlugin';
import { SearchResultType } from '../../types/api/UserInterestAnalyticsTypes';
import { User } from '../../types/api/UsersTypes';
import { ApplicationState } from '../../types/state/storeTypes';

import { connect } from 'react-redux';
import { useEffect, useState } from 'react';
import { createProductPageVisitEvent, touchCookie } from '../../helpers/analytics/userInterestAnalytics';
import algoliaHelpers from '../../helpers/algolia';
import { useRouter } from 'next/router';
import { contentView } from '../../shared/analytics/Facebook';
import { collectionVariantsSortingFunction } from '../../helpers/nonSubscriptionPurchase';

import { QUERY_PARAMS as ALGOLIA_QUERY_PARAMS } from '../../constants/algolia';
import { ENV } from '../../constants/environments';

const ProductPageVisitPlugin: React.FC<ProductPageVisitPluginProps> = ({ user, product, authenticated }) => {
  const router = useRouter();
  const { pushCollectionClickEvent: pushAlgoliaEvents } = algoliaHelpers;
  const [visitReported, setVisitReported] = useState<boolean>(false);

  const mapProductType = (): SearchResultType => {
    switch (product.library.id) {
      case 1: return 'collection-2d';
      case 2: return 'collection-pfl';
      case 3: return 'collection-3d';
      default: return;
    }
  };

  const pushUserInterestAnalyticsEvent = async () => {
    if (ENV.appEnv !== 'production') return;
    const productType = mapProductType();
    if (!productType) return;
    try {
      await createProductPageVisitEvent(
        product.slug,
        product.name,
        productType,
        user,
      );
    } catch {};
  };

  const pushPixelEvent = () => {
    if (ENV.appEnv !== 'production') return;
    const selectedVariant = product.collection_variants.sort(collectionVariantsSortingFunction)[0];
    const price = selectedVariant.price;
    const params = {
      contents: [{ id: product.id, quantity: 1, price }],
      content_ids: [ product.id.toString() ],
      content_type: 'collection',
      value: price,
      currency: 'USD',
    };
    contentView(params);
  };

  const reportPageVisit = async () => {
    pushPixelEvent();
    try {
      await pushUserInterestAnalyticsEvent();
      let position: number;
      if (router.query[ALGOLIA_QUERY_PARAMS.POSITION])
        position = parseInt(router.query[ALGOLIA_QUERY_PARAMS.POSITION] as string);
      await pushAlgoliaEvents(
        user,
        product,
        router.query[ALGOLIA_QUERY_PARAMS.QUERY_ID] as string,
        position
      );
      setVisitReported(true);
    } catch {};
  }

  useEffect(() => {
    touchCookie();
  }, [])

  useEffect(() => {
    if (authenticated !== true && authenticated !== false || !!visitReported) return;
    reportPageVisit();
  }, [authenticated]);

  return <></>;
}

const mapStateToProps = (state: ApplicationState): ProductPageVisitPluginStateProps => ({
  user: state.auth.user as User,
  authenticated: state.auth.authenticated,
});

export default connect(mapStateToProps)(ProductPageVisitPlugin);
